export function TypingDots(): JSX.Element {
  return (
    <div
      className="inline-flex items-center gap-1 text-text-dim"
      role="status"
      aria-label="Assistant is thinking"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current animate-bounce [animation-delay:-0.3s]" />
      <span className="h-1.5 w-1.5 rounded-full bg-current animate-bounce [animation-delay:-0.15s]" />
      <span className="h-1.5 w-1.5 rounded-full bg-current animate-bounce" />
    </div>
  );
}
